import { render, staticRenderFns } from "./signup_form.vue?vue&type=template&id=438532d8&scoped=true"
import script from "./signup_form.vue?vue&type=script&lang=ts"
export * from "./signup_form.vue?vue&type=script&lang=ts"
import style0 from "./signup_form.vue?vue&type=style&index=0&id=438532d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438532d8",
  null
  
)

export default component.exports